import {DesignElementType} from './enum/designElementType';
import {LockStatus} from './enum/lockStatus';
import {User} from './user';

export class ElementLock {
  changeDate: Date;
  elementId: number;
  elementType: DesignElementType;
  lockStatus: LockStatus;
  name: string;
  user: User;
}

export class ElementLockScreen extends ElementLock {
  elementTypeDesc?: string;
  checkRight?: boolean;
}


